export default __webpack_public_path__ + "assets/img/line-awesome.f4b3204d4678bf15ec93569dea727e87.svg";